import { Button } from 'blaze-ui/Button'
import { ChevronLeft, ChevronRight } from 'blaze-ui/icons/24'
import Styles from './Toolbar.module.scss'

interface Props {
  goToPreviousFile?: () => void
  goToNextFile?: () => void
}

export const NavigationButtons = ({ goToPreviousFile, goToNextFile }: Props) => {
  return (
    <div className={Styles.navigationButtons}>
      <Button
        variant="ghost"
        size="xs"
        color="var(--dark-80)"
        frontIcon={ChevronLeft}
        onPress={goToPreviousFile}
        isDisabled={!goToPreviousFile}
      >
        Previous
      </Button>
      <Button
        variant="ghost"
        size="xs"
        color="var(--dark-80)"
        endIcon={ChevronRight}
        onPress={goToNextFile}
        isDisabled={!goToNextFile}
      >
        See Next
      </Button>
    </div>
  )
}
